<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-copyright element-without-heading full-character-formatting" id="copyright">
<div class="text" id="copyright-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content"><b><span class="smallcaps">Neil Peart: Cultural Repercussions</span></b></p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Copyright © 2022 Bradley J. Birzer</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">First published 2015</p>
</div>
</div>
<p class="first first-in-chapter first-full-width copyright-content">All rights reserved. No part of this book may be reproduced or transmitted in any form or by any electronic or mechanical means, including photocopying, recording or by any information storage and retrieval system, without the express written permission of the copyright holder, except where permitted by law.</p>
<p class="subsq copyright-content">The sole purpose of these materials is to educate and entertain. Although every precaution was taken to verify the accuracy of the information contained in this book, the author and publisher assume no responsibility for any errors or omissions. Any perceived slights to specific organizations or individuals are unintentional. No liability is assumed for damages that may result from the use of information contained in this book.</p>
<hr class="implicit-break"/>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content">EBook ISBN: 978-1-68057-300-8</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Trade Paperback ISBN: 978-1-68057-299-5</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Dust Jacket Hardcover ISBN: 978-1-68057-399-2</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content">Cover design by Janet McDonald</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Cover photo by Kelly Drew</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Kevin J. Anderson, Art Director</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Published by</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">WordFire Press, LLC</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">PO Box 1840</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Monument CO 80132</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content">Kevin J. Anderson &amp; Rebecca Moesta, Publishers</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">WordFire Press eBook Edition 2022</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">WordFire Press Trade Paperback Edition 2022</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">WordFire Press Hardcover Edition 2022</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Printed in the USA</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content">Join our WordFire Press Readers Group for</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">sneak previews, updates, new projects, and giveaways.</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Sign up at <a class="content-external-link text-is-url" href="http://wordfirepress.com" target="_blank">wordfirepress.com</a></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?32b44f8a